
TS.ns('WL');

WL.leasingApplicationDocumentsModel = new Class({
    Extends: WL.leasingApplicationBaseModel,

    createProperties: function (config) {

        var me = this,
            cat;
         
        me.parent(config);
         
        var propertyList = me.getDomainProperty('PropertyList');
        if (propertyList) {
            propertyList.on('addNew', me.onPropertyAdded);
            propertyList.on('cellValueChanged', me.onPropertyChanged, me);
        } 

        
        me.CommandCategories.Custom = me.CommandCategories.Custom || { commands: [] };
        cat = me.CommandCategories.Custom.commands;

        // add new command
        if (cat != null) {
            cat.push({
                Code: 'AddComment',
                Text: me.AddCommentCommandText,
                handler: '_addComment'
            });

            for (var i = 0; i < cat.length; i++) {
                if (cat[i].Code === "ExportAndPrint")
                    cat[i].handler = '_exportAndPrint';
            }
        }
    },

    _addComment: function () {
        var me = this,
                    vm,
                    url = '../CommentView/Edit?',
                    params;

        params = {
            popup: true
        };

        url += $.param(params);

        TS.UI.showDomain({
            url: url,
            viewModel: vm,
            popupWidth: 600,
            popupHeight: 300
        }, null);
    },

    onPropertyAdded: function (e) {
        var me = this,
          rec = e.item;

        rec.PropertyTypeCode = new ko.observable('Text');
        rec.EditorName = new ko.observable('Text');
        rec.EditorType = new ko.observable('Text');
    },

    onPropertyChanged: function (e) {
        var me = this,
          rec = e.item;

        if (e.fieldName != 'PropertyId')
            return;

        me.performServerCommand({
            cmd: 'RefreshProperty',
            submitModel: true,
            extraData: {
                NewValue: e.newValue,
                rowIdx: e.rowIdx
            },
            blockUI: true
        })
    },

    _exportAndPrint: function () {
        var me = this;
        me.performServerCommand('ExportAndPrint', true, null,
        function (r) {
            if (r && r.success === true && r.modelData.ExportOpenURL != null)
                window.open(r.modelData.ExportOpenURL);
        });
    },
});

